import store from '@/store';
import base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async indexByGuidelineVersion(guidelineVersionId, params) {
    const _params = {
      factory: store.state.app.factory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'guideline_version',
      parentId: guidelineVersionId,
      modelName: 'guideline_article_version/index',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async indexAnnounce(articleId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await base.index({
      parentName: 'guideline_article',
      parentId: articleId,
      modelName: 'guideline_article_version/index/announce',
      params,
    });
    return res;
  },
  async show(versionId, guidelineVerId) {
    const params = {
      factory: store.state.app.factory.id,
      guideline_version: guidelineVerId,
    };
    const res = await base.show({
      modelName: 'guideline_article_version',
      modelId: versionId,
      params,
    });
    return res;
  },
}